var map = {
	"./auth.js": 9045,
	"./insurance.js": 3862,
	"./layout.js": 1708,
	"./organisation.js": 704,
	"./products.js": 5733,
	"./profile.js": 6967,
	"./stat.js": 441,
	"./upload.js": 6794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2115;